
import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Link, useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToFAQ = () => {
    const faqSection = document.getElementById('faq-section');
    if (faqSection) {
      faqSection.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMenuOpen(false); // Close mobile menu if open
    }
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
    setIsMenuOpen(false);
  };

  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'py-2 sm:py-3 bg-white/95 shadow-md backdrop-blur-md' : 'py-3 sm:py-4 md:py-5 bg-transparent'} border-b border-yellow-300/20`}>
      <div className="container mx-auto px-4 sm:px-6 flex items-center justify-between">
        {/* Logo - Adjusted to a more moderate size */}
        <div onClick={() => handleNavigation('/')} className="flex items-center cursor-pointer">
          <img alt="Kandidatmatch - Rätt person på rätt plats" className="h-14 sm:h-16 md:h-18" src="/lovable-uploads/f96b210c-5067-4948-8a12-b44a112625df.png" />
        </div>

        {/* Desktop Navigation */}
        {!isMobile && <nav className="flex items-center space-x-6 md:space-x-8">
            <button onClick={() => handleNavigation('/anvandingsfall')} className="nav-link">Användingsfall</button>
            <button onClick={() => handleNavigation('/priser')} className="nav-link">Priser</button>
            <button onClick={scrollToFAQ} className="nav-link">FAQ</button>
          </nav>}

        {/* Mobile menu toggle - Simplified hamburger button */}
        {isMobile && <button className="text-darkgray focus:outline-none p-1" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>}

        {/* Call to action buttons - Hidden on mobile */}
        {!isMobile && <div className="flex items-center">
            <button onClick={() => handleNavigation('/auth')} className="text-darkgray mr-4 sm:mr-6 font-montserrat font-bold hover:text-accent transition-colors text-sm sm:text-base">Logga in</button>
            <button onClick={() => handleNavigation('/auth')} className="btn-primary bg-yellow-500 hover:bg-gradient-to-r hover:from-yellow-500 hover:to-yellow-300 text-darkgray shadow-none rounded-full text-sm sm:text-base px-4 py-2 sm:px-5 sm:py-2.5">Börja gratis</button>
          </div>}
      </div>

      {/* Mobile Navigation Dropdown */}
      {isMobile && isMenuOpen && <div className="absolute top-full left-0 right-0 bg-white shadow-lg border-t border-yellow-300/20 animate-slide-in-top">
          <nav className="container mx-auto px-4 sm:px-6 py-4 flex flex-col space-y-3 sm:space-y-4">
            <button onClick={() => handleNavigation('/anvandingsfall')} className="nav-link py-1.5 sm:py-2 block text-left">Användingsfall</button>
            <button onClick={() => handleNavigation('/priser')} className="nav-link py-1.5 sm:py-2 block text-left">Priser</button>
            <button onClick={scrollToFAQ} className="nav-link py-1.5 sm:py-2 block text-left">FAQ</button>
            <button onClick={() => handleNavigation('/auth')} className="text-darkgray font-montserrat font-bold hover:text-accent transition-colors py-1.5 sm:py-2 text-left">Logga in</button>
            <button onClick={() => handleNavigation('/auth')} className="btn-primary py-2 text-left rounded-lg w-full flex justify-center">Börja gratis</button>
          </nav>
        </div>}
    </header>;
};

export default Navbar;
